import { render, staticRenderFns } from "./EndorsementContractSignatures.vue?vue&type=template&id=05bf12fa&scoped=true"
import script from "./EndorsementContractSignatures.vue?vue&type=script&lang=js"
export * from "./EndorsementContractSignatures.vue?vue&type=script&lang=js"
import style0 from "./EndorsementContractSignatures.vue?vue&type=style&index=0&id=05bf12fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bf12fa",
  null
  
)

export default component.exports